import { Alert, Box, Button, Card, CardContent, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useCallback, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import DefaultApiService from "../../../../infrastructure/api/default.js";
import CopyTextField from "../../partner-commission/components/CopyTextField";

const PAGE_BG = "#F6F8FB";

const ContractorReferralPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await DefaultApiService.getApi(
        "SLN/Contractor/ContractorReferral/GetReferral"
      );
      const isSuccess = res?.isSuccess ?? res?.IsSuccess;
      if (!isSuccess) {
        setError(res?.message || res?.Message || "بارگذاری اطلاعات معرفی ناموفق بود.");
        setData(null);
        return;
      }
      setData(res?.data ?? res?.Data ?? null);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, background: PAGE_BG, minHeight: "100%" }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
            لینک اختصاصی معرفی متقاضی
          </Typography>
          <Typography variant="body2" color="text.secondary">
            لینک یا کد معرف زیر را در اختیار متقاضیان قرار دهید.
          </Typography>
        </Box>
        <Button
          component={RouterLink}
          to="/SLN/Contractor/ContractorReferralLeads"
          variant="outlined"
          startIcon={<AssessmentOutlinedIcon />}
        >
          گزارش معرفی‌های من
        </Button>
      </Stack>

      {loading ? (
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress />
        </Box>
      ) : null}

      {!loading && error ? (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          action={
            <Button color="inherit" size="small" onClick={load}>
              تلاش مجدد
            </Button>
          }
        >
          {error}
        </Alert>
      ) : null}

      {!loading && !error ? (
        <>
          <Alert severity="info" sx={{ mb: 2 }}>
            در صورت درخواست متقاضی با استفاده از کد شما، پروژه به شما ارجاع خواهد شد.
          </Alert>

          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <CopyTextField
                    label="کد معرف"
                    value={data?.referralCode}
                    copyMessage="کد معرف کپی شد."
                  />
                </Grid>
                <Grid item xs={12}>
                  <CopyTextField
                    label="لینک معرفی متقاضی"
                    value={data?.referralLink}
                    copyMessage="لینک معرف کپی شد."
                  />
                </Grid>
                <Grid item xs={12}>
                  <CopyTextField
                    label="متن آماده اشتراک‌گذاری"
                    value={data?.shareText}
                    copyMessage="متن اشتراک‌گذاری کپی شد."
                    multiline
                    rows={3}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </>
      ) : null}
    </Box>
  );
};

export default ContractorReferralPage;
